import Vue from 'vue';

const success = (context, index, type) => {
    context.userTemplates.splice(index, 1);
    context.addNewFeldToTemplates('change');
    context.isTemplateDeleting = false;
    toastr.success(context.$t('message_templates.template_deleted'));
};

const failed = (context) => {
  context.isTemplateDeleting = false;
  toastr.error(context.$t('message_templates.template_not_found'));

};

export default(context, index, type, id) => {
   return Vue.$http.delete('/message-templates/'+id)
     .then(response => {
        if(response.status === 200) {
          success(context, index, type);
        }
     }).catch(error => {
        failed(context);
     })
}



// WEBPACK FOOTER //
// ./src/app/services/message-template/deleteTemplate.js